import { useEffect } from "react";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { PortalTop } from "@/features/shell/PortalTop";
import { SessionExpired } from "@/features/shell/SessionExpired";
import { showLanguage } from "@/i18n";
import { isSessionGone } from "@/lib/api";
import { meQuery } from "@/lib/auth";
import { session } from "@/lib/session";

// The portal itself, signed in with a company: the bar on top, the page, and the modal when the session
// ends (H-g04). Before it: no session → signing in (and back here after); a recovery code → a new phone
// first; more than one company and none chosen → choosing one (docs/auth.md §3a and §5).

export const Route = createFileRoute("/_portal")({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery).catch((err: unknown) => {
      if (isSessionGone(err)) throw redirect({ to: "/login", search: { next: location.href } });
      throw err;
    });
    if (me.mustRelink) throw redirect({ to: "/new-phone" });
    if (me.needsParty) throw redirect({ to: "/choose-company", search: { next: location.href } });
  },
  component: PortalLayout,
});

function PortalLayout() {
  const { data: me } = useSuspenseQuery(meQuery);

  useEffect(() => {
    session.started();
  }, []);
  // The account's language, which the mails use too.
  useEffect(() => {
    showLanguage(me.user.language);
  }, [me.user.language]);

  return (
    <div data-screen-label="Portaal">
      <PortalTop me={me} />
      <main>
        <Outlet />
      </main>
      <SessionExpired />
    </div>
  );
}
